// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {useEffect, useMemo, useState, RefObject} from 'react';

interface i_use_in_view_options {
    threshold?: number;
    margin?: string;
    viewport?: RefObject<HTMLElement>;
    once?: boolean;
}

export const use_in_view =
    (ref: RefObject<HTMLElement>, options?: i_use_in_view_options)=>{
    const {threshold, margin, viewport, once} = options||{};
    const [is_in_view, set_is_in_view] = useState(false);
    const observer = useMemo(()=>{
        if (!('IntersectionObserver' in window))
            return null;
        return new IntersectionObserver(
            ([entry])=>set_is_in_view(once
                ? is_in_view||entry.isIntersecting
                : entry.isIntersecting),
            {threshold, rootMargin: margin, root: viewport?.current});
    }, [ref]);
    useEffect(()=>{
      observer?.observe(ref.current);
      return ()=>observer?.disconnect();
    }, [ref]);
    return is_in_view;
};
